import { isString } from './checks'
const ALL_WHITE_SPACE_REGEX = /\s/gi
const ALL_DASHES_REGEX = /-/gi
const ALL_LUXURYREHABS_URLS = /(http|https):\/\/luxuryrehabs.(com|in)[/]?/gi
const ALL_LUXURYREHABS_URLS_RETAIN_TRAILING_SLASH =
  /(http|https):\/\/luxuryrehabs.(com|in)?/gi
const BLOG_PATH_REGEX = new RegExp('[/]?blog/', 'ig')

export const replaceInStringWith = (
  originalStr = '',
  pattern: string | RegExp = '',
  replaceStr = ''
): string => {
  if (!isString(originalStr)) {
    return ''
  }
  return originalStr.replace(pattern, replaceStr)
}

export const removeFromString = (
  originalStr: string,
  pattern: string | RegExp
) => replaceInStringWith(originalStr, pattern, '')

export const removeLuxuryRehabUrlFromString = (originalStr: string) =>
  replaceInStringWith(originalStr, ALL_LUXURYREHABS_URLS, '')

export const removeLuxuryRehabUrlFromStringRetainTrailingSlash = (
  originalStr: string
) =>
  replaceInStringWith(
    originalStr,
    ALL_LUXURYREHABS_URLS_RETAIN_TRAILING_SLASH,
    ''
  )

export const replaceAllSpacesInStringWith = (
  str: string,
  replaceStr: string
): string => replaceInStringWith(str, ALL_WHITE_SPACE_REGEX, replaceStr)

export const replaceAllSpacesWithDashes = (str: string) =>
  replaceAllSpacesInStringWith(str, '-')

export const removeWhiteSpaces = (str: string) =>
  replaceAllSpacesInStringWith(str, '')

export const replaceAllDashedInStringWith = (
  str: string,
  replaceStr: string
): string => replaceInStringWith(str, ALL_DASHES_REGEX, replaceStr)

export const replaceAllDashesWithSpaces = (str: string) =>
  replaceAllDashedInStringWith(str, ' ')

export const removeAllDashes = (str: string) =>
  replaceAllDashedInStringWith(str, '')

export const fixBlogUrls = (text: string) => {
  const hasBlogPath = BLOG_PATH_REGEX.test(text)
  if (!hasBlogPath) {
    return text
  }

  return replaceInStringWith(
    replaceInStringWith(text, ALL_LUXURYREHABS_URLS, '/'),
    BLOG_PATH_REGEX,
    '/resources/'
  )
}
